var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaptureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 21.146 21.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21314b",
    d: "M3 3h2.35v2.35H3zm4.7 0h2.35v2.35H7.7zm4.7 0h2.35v2.35H12.4zm4.7 0h2.35v2.35H17.1zm4.7 0h2.35v2.35H21.8zm0 4.7h2.35v2.35H21.8zM3 21.8h2.35v2.35H3zm0-4.7h2.35v2.35H3zm0-4.7h2.35v2.35H3zm0-4.7h2.35v2.35H3zm9.007 4.7l1.217-1.827a1.175 1.175 0 0 1 .977-.523h3.442a1.175 1.175 0 0 1 .978.523l1.217 1.827h3.133a1.175 1.175 0 0 1 1.175 1.175v9.4a1.175 1.175 0 0 1-1.175 1.175H8.874A1.175 1.175 0 0 1 7.7 22.972v-9.4A1.175 1.175 0 0 1 8.874 12.4zm-1.958 9.4H21.8v-7.052h-3.219L17.015 12.4H14.83l-1.566 2.35h-3.215zm5.874-1.175a2.35 2.35 0 1 1 2.35-2.35 2.35 2.35 0 0 1-2.35 2.347z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureIcon);
export default __webpack_public_path__ + "static/media/CaptureIcon.78b1a50a39d28986367f67b74ea91d7e.svg";
export { ForwardRef as ReactComponent };